<template>
  <div
    class="tw-text-secondary-700 tw-flex tw-flex-row tw-justify-end tw-items-center tw-gap-4 tw-rounded-md"
  >
    <label
      class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-secondary-700 tw-cursor-pointer tw-select-none"
    >
      <Switch
        :model-value="includeRecurring"
        @update:model-value="handleIncludeRecurringChange($event)"
      />
      {{ t('statistics.filters.include_recurring') }}
    </label>
    <div class="tw-w-80">
      <DateRange
        :initial-date="[startOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 }), new Date()]"
        @selectDate="handleDateRangeChange($event)"
        :clearSelectsEmptyRange="true"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import moment from 'moment';
import { startOfWeek, endOfWeek, subWeeks } from 'date-fns';
import { useI18n } from 'vue-i18n';
import { Switch } from '@/components/ui/switch';
import { useCustomerStore } from '@/stores/customer.store';

// Define emit first
const emit = defineEmits(['update:filters']);

const { t } = useI18n();
const { selectedCustomerId } = storeToRefs(useCustomerStore());

// date range selection
const selectedDateRange = ref<{ startDate: string; endDate: string }>({
  startDate: moment(startOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 })).format('YYYY-MM-DD'),
  endDate: moment(endOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 })).format('YYYY-MM-DD'),
});

// include recurring orders (and their linked payments) in the statistics
const includeRecurring = ref(true);

const updateFilters = () => {
  // Don't emit until we have a valid customer ID
  if (!selectedCustomerId.value) {
    return;
  }

  emit('update:filters', {
    customerId: selectedCustomerId.value,
    startDate: selectedDateRange.value.startDate,
    endDate: selectedDateRange.value.endDate,
    includeRecurring: includeRecurring.value,
  });
};

// Watch for customer changes and emit updated filters
watch(
  selectedCustomerId,
  () => {
    updateFilters();
  },
  { immediate: true }
);

const handleDateRangeChange = async range => {
  selectedDateRange.value = { ...range };
  updateFilters();
};

const handleIncludeRecurringChange = (value: boolean) => {
  includeRecurring.value = value;
  updateFilters();
};
</script>
